export default __webpack_public_path__ + "static/media/me.89173a72.png";